/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Pa } from "./Pa";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const IbanValidiPerPaR = t.interface({});

// optional attributes
const IbanValidiPerPaO = t.partial({
  chiaveAvvio: t.string,

  chiaveEsito: t.string,

  dataInizioValidita: UTCISODateFromString,

  dataPubblicazione: UTCISODateFromString,

  fkPa: t.Integer,

  ibanAccredito: t.string,

  idBancaSeller: t.string,

  idMerchant: t.string,

  masterObj: t.Integer,

  objId: t.Integer,

  ragioneSociale: t.string
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type IbanValidiPerPa = t.TypeOf<typeof IbanValidiPerPaR> &
  t.TypeOf<typeof IbanValidiPerPaO> & {
  readonly "pa"?: Pa;
  };

export const IbanValidiPerPa: t.Type<IbanValidiPerPa> = t.recursion("IbanValidiPerPa", () =>
  t.intersection(
    [IbanValidiPerPaR, t.partial({ ...IbanValidiPerPaO.props, "pa": Pa })],
    "IbanValidiPerPa"
  ) as unknown as t.Type<IbanValidiPerPa>
);
